import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { api } from "../services/api-service";

import { success } from "./notificationSlice";

const initialState = {
  lookup: {},
  allLookups: [],
  lookupTypes: [],
};

export const addNewLookup = createAsyncThunk(
  "addLookup",
  async ({ key, value }, { rejectWithValue, dispatch }) => {
    try {
      const response = await api.post("add-lookup", {
        type: key,
        id: value,
      });
      if (response?.ok) {
        dispatch(success({ message: "Lookup added successfully" }));
        dispatch(getAllLookups());
        return { ...response };
      } else throw new Error({ ...response });
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteLookup = createAsyncThunk(
  "deleteLookup",
  async (id, { rejectWithValue, dispatch }) => {
    try {
      const response = await api.delete(`delete-lookup/${id}`);
      if (response?.ok) {
        dispatch(success({ message: "Lookup deleted successfully" }));
        dispatch(getAllLookups());
        return { ...response };
      } else throw new Error({ ...response });
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getAllLookups = createAsyncThunk(
  "getAllLookup",
  async (params, { rejectWithValue }) => {
    try {
      const response = await api.get("all-lookup");
      if (response?.ok) return { ...response };
      else throw new Error({ ...response });
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const lookupSlice = createSlice({
  name: "lookup",
  initialState,
  reducers: {
    addLookup: (state, action) => {
      state.lookup[action.payload.type] = action.payload.value;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllLookups.fulfilled, (state, action) => {
      state.allLookups = action.payload.data.data;
      state.lookupTypes = action.payload.data.data.filter(
        (look) => look.type === "lookupType"
      );
    });
  },
});

// Action creators are generated for each case reducer function
export const { addLookup } = lookupSlice.actions;
export const lookupSelector = (state) => state.lookup.lookup;
export const allLookupSelector = (state) => state.lookup.allLookups;
export const lookupTypesSelector = (state) => state.lookup.lookupTypes;

export default lookupSlice.reducer;
